import { SearchInput } from '@/components/ui/SearchInput';
import { cn } from '@/utils/cn';

interface GridSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
}

export const GridSearchInput = ({ value, onChange, className, placeholder }: GridSearchInputProps) => {
  return (
    <SearchInput
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={cn('max-w-96', className)}
      data-testid="grid-search-input"
    />
  );
};
